import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "rounded-md bg-red-50 p-4 text-left mt-3" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm font-medium text-red-800" }
const _hoisted_10 = { class: "mt-6 pb-2 text-left" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "mt-2 pb-2 text-left" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = { class: "mt-2 pb-2 text-left" }
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = { class: "mt-1" }
const _hoisted_19 = { class: "mt-2 pb-2 text-left" }
const _hoisted_20 = {
  for: "location",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mt-2 pb-2 text-left" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = { class: "mt-1" }
const _hoisted_25 = { class: "mt-2 pb-2 text-left" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { class: "mt-2 pb-2 text-left" }
const _hoisted_29 = { class: "text-sm" }
const _hoisted_30 = { class: "mt-1" }
const _hoisted_31 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }
const _hoisted_32 = ["disabled"]

import { computed, ref, onMounted } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  XCircleIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import { useStore } from "vuex";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePlayerDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const newUserForm = ref({
  username: "",
  password: "",
  phoneNumber: "",
  accountNameTh: "",
  accountNumber: "",
  bankName: "",
  bankCode: "",
  operatorId: store.state.selectedOperator.operatorId,
  affiliate_username: "",
});

const bankList = ref([
  {
    bankCode: "",
    description: "-- Select Bank --",
  },
  // {
  //   bankCode: "KBANK",
  //   description: "Kasikorn bank",
  // },
  // {
  //   bankCode: "SCB",
  //   description: "Siam commercial bank",
  // },
  // {
  //   bankCode: "KTB",
  //   description: "Krung Thai bank",
  // },
  // {
  //   bankCode: "BBL",
  //   description: "Bangkok Bank",
  // },
  // {
  //   bankCode: "BAY",
  //   description: "Krungsri Bank",
  // },
  // {
  //   bankCode: "TTB",
  //   description: "Thai Military Thanachart Bank",
  // },
  // {
  //   bankCode: "LHBANK",
  //   description: "LH Bank",
  // },
  // {
  //   bankCode: "IBANK",
  //   description: "Islam Bank",
  // },
  // {
  //   bankCode: "UOB",
  //   description: "UOB Bank",
  // },
  // {
  //   bankCode: "GSB",
  //   description: "Government Saving Bank",
  // },
  // {
  //   bankCode: "BAAC",
  //   description: "BAAC",
  // },
  // {
  //   bankCode: "CIMB",
  //   description: "CIMB",
  // },
  // {
  //   bankCode: "GHBANK",
  //   description: "GHBANK",
  // },
  // {
  //   bankCode: "KK",
  //   description: "Kiatnakin Bank",
  // },
  // {
  //   bankCode: "PSV",
  //   description: "Phongsavanh Bank",
  // },
  // {
  //   bankCode: "LDB",
  //   description: "Lao Development Bank",
  // },
  // {
  //   bankCode: "APB",
  //   description: "Agricultural Promotion Bank",
  // },
  // {
  //   bankCode: "JDB",
  //   description: "Joint Development Bank",
  // },
  // {
  //   bankCode: "BCEL",
  //   description: "Banque Pour Le Commerce Exterieur Lao Public",
  // },
  // {
  //   bankCode: "LVB",
  //   description: "LAO VIET BANK",
  // },
  // {
  //   bankCode: "STB",
  //   description: "ST Bank Laos",
  // },
  // {
  //   bankCode: "LPDR",
  //   description: "Lao PDR",
  // },
  // {
  //   bankCode: "SACB",
  //   description: "Sacombank",
  // },
  // {
  //   bankCode: "IDCB",
  //   description: "Indochina Bank",
  // },
  // {
  //   bankCode: "VIB",
  //   description: "Vietinbank",
  // },
]);

const bankAccount = ref({
  bank: bankList.value[0].bankCode,
  accountNumber: "",
});

const errorMessage = ref("");
const isWorking = ref(false);
const hasError = ref(false);

const createPlayer = () => {
  // isWorking.value = true;
  // hasError.value = false;

  newUserForm.value.phoneNumber = newUserForm.value.phoneNumber.replace(
    "0",
    "+66"
  );

  newUserForm.value.bankName = bankList.value.find(
    (b) => b.bankCode == bankAccount.value.bank
  )!.description;

  newUserForm.value.bankCode = bankAccount.value.bank;


  if(!newUserForm.value.accountNumber.length || !/^\d+$/.test(newUserForm.value.accountNumber)){
      alert('กรุณากรอกเลขบัญชีที่ถูกต้อง')
      return
  }

  if(!newUserForm.value.accountNameTh.length || /\d+/.test(newUserForm.value.accountNameTh)){
      alert('กรุณากรอกชื่อบัญชีที่ถูกต้อง')
      return
  }
  axios
    .post(
      process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/auth/create-user-internal",
      newUserForm.value,
      {
        headers: {
          "x-cm-operator-id": store.state.selectedOperator.operatorId,
        },
      }
    )
    .then(({ data }) => {
      newUserForm.value = {
        username: "",
        password: "",
        phoneNumber: "",
        accountNameTh: "",
        accountNumber: "",
        bankName: "",
        bankCode: "",
        operatorId: store.state.selectedOperator.operatorId,
        affiliate_username: "",
      };
      // console.log("🚀 ~ data", data);
      emit("submit");
      isWorking.value = false;
    })
    .catch((err) => {
      switch (err.response.data.message) {
        case "INVALID_BANK_ACCOUNT":
          errorMessage.value =
            "ไม่พบบัญชีธนาคาร หรือบัญชีธนาคารได้รับลงทะเบียนแล้ว";
          break;

        case "USER_EXISTS":
          errorMessage.value = "เบอร์โทรหรือชื่อผู้ใช้ได้รับการลงทะเบียนแล้ว";
          break;

        case "INVALID_USER":
          errorMessage.value = "บัญชีนี้อยู่ในรายชื่อผู้ถูก Blacklist";
          break;

        default:
          errorMessage.value = "เกิดข้อผิดพลาด กรุณาติดต่อผู้ดูแล";
          break;
      }
      isWorking.value = false;
      hasError.value = true;
      console.log(err);
    });
};
onMounted(() => {
      refetch();
    });

    const refetch = () => {

      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/banks`;
      const banksPayload = {
          "requestId": Date.now(),
          "requestTs": Date.now(),
          "is_active": true
      }
      axios.post(url, banksPayload).then(({ data }) => {
        bankList.value = (data.map((bank: any) => ({
          bankCode: bank.bank_code,
          description: `${bank.name_th} (${bank.bank_code})`
        })))
        bankList.value.unshift(
        {
          bankCode: "",
          description: "-- Select Bank --",
        }) 
      }).catch((err) => {
        console.log(err);
      });
    };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[9] || (_cache[9] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.players.createNewPlayer")), 1)
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(XCircleIcon), {
                              class: "h-5 w-5 text-red-400",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("h3", _hoisted_9, _toDisplayString(errorMessage.value), 1)
                          ])
                        ])
                      ], 512), [
                        [_vShow, hasError.value]
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("messages.players.username")), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newUserForm.value.username) = $event)),
                            name: "username",
                            id: "username",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newUserForm.value.username]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("messages.players.password")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            type: "password",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newUserForm.value.password) = $event)),
                            name: "password",
                            id: "password",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newUserForm.value.password]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("messages.players.phoneNumber")), 1),
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "11",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newUserForm.value.phoneNumber) = $event)),
                            name: "phoneNumber",
                            id: "phoneNumber",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newUserForm.value.phoneNumber]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("messages.players.selectBank")), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "location",
                          name: "location",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bankAccount.value.bank) = $event)),
                          class: "capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, (bank) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: bank.bankCode,
                              value: bank.bankCode
                            }, _toDisplayString(bank.description), 9, _hoisted_21))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, bankAccount.value.bank]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("messages.players.bankAccountName")), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newUserForm.value.accountNameTh) = $event)),
                            name: "accountNameTh",
                            id: "accountNameTh",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newUserForm.value.accountNameTh]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("messages.players.bankAccountNumber")), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newUserForm.value.accountNumber) = $event)),
                            name: "accountNumber",
                            id: "accountNumber",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newUserForm.value.accountNumber]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("messages.players.affiliateUsername")), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newUserForm.value.affiliate_username) = $event)),
                            name: "affiliate_username",
                            id: "affiliate_username",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newUserForm.value.affiliate_username]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none sm:col-start-2 sm:text-sm", isWorking.value
                    ? 'bg-gray-500'
                    : ' bg-blue-600  hover:bg-blue-700  focus:ring-blue-500 focus:ring-2 focus:ring-offset-2'
                  ]),
                      disabled: isWorking.value,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (createPlayer()))
                    }, _toDisplayString(_ctx.$t("messages.players.createPlayer")), 11, _hoisted_32),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cancel'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                      ref: "cancelButtonRef"
                    }, " Cancel ", 512)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})